import { AppRoutes, PublicRoutes } from "./router";
import { AppProvider, AuthenticatedProviders } from "./provider";
import { useLocation } from "wouter";

/*
 * App component
 *
 * This is the root component of the application
 */
function App() {
  /* Hooks */
  const [location] = useLocation();

  // We consider any route that starts with /auth to be a public route.
  const isPublicRoute = location.startsWith("/auth");

  return (
    <AppProvider>
      {isPublicRoute ? (
        <PublicRoutes />
      ) : (
        <AuthenticatedProviders>
          <AppRoutes />
        </AuthenticatedProviders>
      )}
    </AppProvider>
  );
}

export default App;
